/****************************************************************************
 * COPYRIGHT (c) 2025 Harman Connected Services
 *
 * All rights reserved
 *
 * This software embodies materials and concepts which are
 * confidential to Ignite Product and is made available solely
 * pursuant to the terms of a written license agreement with
 * Ignite Product.
 *
 * Designed and Developed by Harman International Industries, Inc.
 ***************************************************************************/
import {
  FETCH_DOMAIN_APPROVER_COUNTRY_DETAILS_REQUEST,
  FETCH_DOMAIN_APPROVER_COUNTRY_DETAILS_SUCCESS,
  FETCH_DOMAIN_APPROVER_COUNTRY_DETAILS_FAILURE,
} from "./DomainApproverCountryTypes";

const initialState = {
  countries: [],
  loading: false,
  error: null,
};

const domainApproverCountriesReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_DOMAIN_APPROVER_COUNTRY_DETAILS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_DOMAIN_APPROVER_COUNTRY_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        countries: action.payload || [],
        error: null,
      };
    case FETCH_DOMAIN_APPROVER_COUNTRY_DETAILS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default domainApproverCountriesReducer;
